import { type TextProps } from '@pets-ui/Text/Text'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type CSSProperties } from 'react'

interface AmountProps {
  variant?: TextProps['variant']
  amount: number
  isHasSpace?: boolean
  color?: CSSProperties['color']
  isNegative?: boolean
  isLineThrough?: boolean
  isBold?: boolean
}

export const Amount = ({
  variant = 'body',
  amount,
  isHasSpace = false,
  color = colors.black,
  isNegative = false,
  isLineThrough = false,
  isBold = false,
}: AmountProps) => {
  const isPositiveAmount = amount >= 0
  return (
    <Text variant={variant} color={color} textDecoration={isLineThrough ? 'line-through' : undefined} bold={isBold}>
      {!isPositiveAmount || isNegative ? '-' : ''}
      {'$'}
      {isHasSpace ? ' ' : ''}
      {Math.abs(amount).toLocaleString()}
    </Text>
  )
}
